import { sleep } from '@flowus/common/async';
import { cx } from '@flowus/common/cx';
import type { SubscribeInfo } from '@flowus/common/subscribe/type';
import { sampleSize } from 'lodash-es';
import { useCallback, useEffect, useState, type FC } from 'react';
import { Icon } from 'src/common/components/icon';
import { publicLink } from 'src/common/const';
import { useFetchPage } from 'src/hooks/page';
import { ID_TOC_CONTAINER } from 'src/hooks/page/use-dnd/helper';
import { cache } from 'src/redux/store';
import { useSubscribePages } from 'src/services/app';
import { bizTracker } from 'src/utils/biz-tracker';
import { TocGroupHeader } from '../toc/toc-group-header';
import { TocItem } from '../toc/toc-item';
import { TocType } from '../toc/types';
import { fetchData } from './center/subscribe-center';

/** 订阅toc */
export const SubscribeToc: FC = () => {
  const tocItems = useSubscribePages();
  const [subscribeInfo, setSubscribeInfo] = useState<SubscribeInfo[]>([]);
  const [recomendSubscribeInfo, setRecomendSubscribeInfo] = useState<SubscribeInfo[]>();
  const fetchPage = useFetchPage();

  const [subscribeHidden, _] = useState(false);
  const [showAnimate, setShowAnimate] = useState(false);

  const sampleSubscribe = useCallback(
    (info: SubscribeInfo[]) => {
      const ret = sampleSize(info, 6);
      ret.forEach((v) => {
        if (!cache.blocks[v.id]) {
          void fetchPage(v.id);
        }
      });
      setRecomendSubscribeInfo(ret);
    },
    [fetchPage]
  );

  useEffect(() => {
    void fetchData().then((res) => {
      const finalResult: SubscribeInfo[] = [];
      let freeCount = 0;
      // 只推荐付费订阅和免费的前15个;
      res?.forEach((r) => {
        r.subscribeInfo?.forEach((a) => {
          if (a.accessFee) {
            finalResult.push(a);
          } else if (freeCount < 15) {
            finalResult.push(a);
            freeCount++;
          }
        });
      });

      setSubscribeInfo(finalResult);
      sampleSubscribe(finalResult);
    });
  }, [fetchPage, sampleSubscribe]);
  if (!tocItems) return null;

  return (
    <div id={ID_TOC_CONTAINER} className="h-full min-h-17.5 overflow-y-auto pb-10 space-y-2">
      <TocGroupHeader
        showCreateButton={false}
        type={TocType.PRIVATE}
        tooltipDesc="我订阅的页面"
        title="我的订阅"
        addonAfter={
          !__BUILD_IN__ && (
            <a
              href={publicLink.subscribeCenter}
              target="_blank"
              className="flex underline underline-offset-2 items-center animate-hover px-1 mr-3 animate-click space-x-1 text-t4"
              onClick={() => {
                bizTracker.event('knowledge', { is_from: 'up_to_knowledge' });
              }}
            >
              <span>去知识库订阅</span>
              <Icon name="IcJumpTo" size="middle" />
            </a>
          )
        }
      >
        {tocItems.map((tocId, index) => {
          return <TocItem key={index} uuid={tocId} deep={0} />;
        })}
        {!tocItems.length && (
          <div className="text-t4 space-y-2 text-grey3 text-center flex items-center justify-center flex-col py-4">
            <Icon name="IcSubscribe" size="middle" />
            <span>暂无内容，快去知识库订阅吧～</span>
          </div>
        )}
      </TocGroupHeader>
      {!subscribeHidden && (
        <div className="relative bg-aside rounded">
          <TocGroupHeader
            showCreateButton={false}
            type={TocType.RECOMMEND}
            tooltipDesc="精选栏目推荐"
            title="精选栏目推荐"
            addonAfter={
              <Icon
                className={cx('mr-4', {
                  'animate-spin': showAnimate,
                  hidden: subscribeInfo.length === 0,
                })}
                name={'IcRefresh'}
                size="small"
                onClick={async () => {
                  setShowAnimate(true);
                  sampleSubscribe(subscribeInfo);
                  await sleep(1000);
                  setShowAnimate(false);
                }}
              />
            }
          >
            {recomendSubscribeInfo?.map((info, index) => {
              return <TocItem key={index} uuid={info.id} deep={0} />;
            })}
            {!recomendSubscribeInfo?.length && (
              <div className="text-t4 space-y-2 text-grey3 text-center">
                <span>暂无内容，去知识库看看吧～</span>
              </div>
            )}
          </TocGroupHeader>
        </div>
      )}
      {/* <div
        className="hidden cursor-pointer hover:bg-black_006 animate-click border-t w-full text-center text-t2-medium py-3"
        onClick={() => {
          openModal.warning;
          openModal.modal({
            content: ({ onCloseModal }) => (
              <div className="next-modal p-5 w-[400px]">
                <div className="text-left text-t2">
                  <div>申请退款前，请先阅读以下说明：</div>
                  <div className="mt-4">1.为了保障你和创作者的权益，可在购买后48小时内申请退款</div>
                  <div className="mt-0.5">
                    <div>2.如需退款，需提供两个信息：</div>
                    <div>- 订单截图，要确保能看见订单号</div>
                    <div>- 退款原因</div>
                  </div>
                  <div className="mt-0.5">3.非实时处理，我们会在48小时内审核，请耐心等待。</div>
                  <div className="mt-4">如确认退款，请填写退款申请表</div>
                </div>
                <div className="flex mt-6 justify-end">
                  <Button className="flex-1" colorType="secondary" onClick={() => onCloseModal()}>
                    关闭
                  </Button>
                  <Button
                    className="flex-1 ml-2.5"
                    colorType="active"
                    onClick={() => {
                      window.open('https://flowus.cn/form/275fa97c-46be-4f5c-8d51-12fb2f8650eb');
                    }}
                  >
                    填写退款申请表
                  </Button>
                </div>
              </div>
            ),
          });
        }}
      >
        申请退款
      </div> */}
    </div>
  );
};
